module.exports = {"postcode":"Postcode","postcode_us":"Zip code","enter_postcode":"Enter postcode","enter_postcode_us":"Enter Zip code","dont_remember":"Don't remember?","select_province":"Select province below","select_province_us":"Select state below","address":"Address","address_enter":"Enter your address","blocked_postal":"The postal code you entered is not valid","incorrect_address":"Sorry, we couldn’t find any address matching","manual_address_flow":"Enter address manually"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/postalCode.json
// module id = 653
// module chunks = 247 1438